var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gr-border container"},[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-4 offset-4 mt-4"},[_c('p',[_c('button',{staticClass:"btn btn-yellow",on:{"click":_vm.signUp}},[_vm._v("Sign Up")])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 text-center mt-4 mb-4"},[_c('h2',[_vm._v("Please sign up to see previous registrations.")])])
}]

export { render, staticRenderFns }